import 'react-app-polyfill/ie9' // For IE 9-11 support
import 'react-app-polyfill/ie11' // For IE 11 support

import React from 'react'
import App from './pages/App'
import { createRoot } from 'react-dom/client'
import registerServiceWorker from './registerServiceWorker'

const root = createRoot(document.getElementById('root'))
root.render(<App />)
registerServiceWorker()
